export default __webpack_public_path__ + "static/media/10H.c8c8e4de.svg";